var map = {
	"./AppStore.svg": "fdc4",
	"./GooglePlay.svg": "b1b4",
	"./NewsCardPhoto.png": "1e26",
	"./WebinarCardPhoto.png": "8104",
	"./active-delivery.svg": "8d478",
	"./active-language.svg": "251f",
	"./active-round.svg": "7f77",
	"./active-tick.svg": "573c",
	"./arrow.svg": "1106",
	"./author-avatar.png": "a2d1",
	"./back.svg": "a11e",
	"./blicks.png": "5c19",
	"./burger.svg": "6ab0",
	"./cart.svg": "d176",
	"./categoryDuhovniyePraktiki.png": "dc55",
	"./categoryFizichiskiyePraktiki.png": "6d9e",
	"./categoryIskusstvo.png": "f1d3",
	"./categoryMirozdanie.png": "2979",
	"./categoryPsychologiya.png": "70e8",
	"./categorySamorealizaciya.png": "51c2",
	"./clock.svg": "6e22",
	"./courseChelovek.png": "881e",
	"./courseSotvoreniye.png": "ed2d",
	"./courseVselennaya.png": "2d40",
	"./eye.svg": "9be9",
	"./fb.svg": "cc3b",
	"./google.svg": "ccc8",
	"./icon-check.svg": "9d18",
	"./inst.svg": "cc17",
	"./itemChelovek.png": "4341",
	"./itemSotvoreniye.png": "f69f",
	"./itemVselennaya.png": "d537",
	"./lang-en.svg": "e86b",
	"./lang-ru.svg": "578c",
	"./logo-text.svg": "38b8",
	"./logo.svg": "1ae4",
	"./next.svg": "dd0a",
	"./notebookMan.svg": "d3a1",
	"./order-check.svg": "9e70",
	"./order-cross.svg": "5b41",
	"./pause.svg": "5546",
	"./personal.svg": "e1b2",
	"./phones.png": "f1a6",
	"./play.svg": "cc2e",
	"./right-arrow.svg": "215d",
	"./sertificate.png": "7950",
	"./small-pause.svg": "189f",
	"./small-play.svg": "ad13",
	"./volume.svg": "f5e6",
	"./yt.svg": "441d",
	"./zen.svg": "05a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";